import { styled } from '@mui/material/styles';

export const BoldValue = styled('span', {
  name: 'BoldValue',
})(() => ({
  fontWeight: 700,
}));
